import { render } from "./ThresholdRangeSlider.vue?vue&type=template&id=3fb6c812&scoped=true"
import script from "./ThresholdRangeSlider.vue?vue&type=script&lang=js"
export * from "./ThresholdRangeSlider.vue?vue&type=script&lang=js"

import "./ThresholdRangeSlider.vue?vue&type=style&index=0&id=3fb6c812&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb6c812"]])

export default __exports__